module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/helper-43.7efb3baf.png";